/* istanbul ignore file */
export const APPEND_EMPLOYEE_NAMES = 'APPEND_EMPLOYEE_NAMES';
export const REMOVE_EMPLOYEE_NAMES = 'REMOVE_EMPLOYEE_NAMES';
export const CLEAR_EMPLOYEE_NAMES = 'CLEAR_EMPLOYEE_NAMES';

export const appendEmployeeNames = (employeeNames: any) => ({
  type: APPEND_EMPLOYEE_NAMES,
  employeeNames,
});

export const removeEmployeeNames = (employeeNamesAliases: string[]) => ({
  type: REMOVE_EMPLOYEE_NAMES,
  employeeNamesAliases,
});

export const clearEmployeeNames = () => ({
  type: CLEAR_EMPLOYEE_NAMES,
});
